import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import { io } from 'socket.io-client';
import AdviceModal from '../../components/doctors/modals/advice';
import ChiefComplainModal from '../../components/doctors/modals/chiefComplain';
import DiagnosisModal from '../../components/doctors/modals/diagnosis';
import EyeGlassModal from '../../components/doctors/modals/eyeGlass';
import FollowUpModal from '../../components/doctors/modals/followUp';
import HistoryModal from '../../components/doctors/modals/history';
import InfertilityModal from '../../components/doctors/modals/infertility';
import InvestigationModal from '../../components/doctors/modals/investigation';
import OnExaminationModal from '../../components/doctors/modals/onExamination';
import PredictionsModal from '../../components/doctors/modals/predictions';
import ReferredToModal from '../../components/doctors/modals/referredTo';
import RehabilitationModal from '../../components/doctors/modals/rehabilitation';
import RxModal from '../../components/doctors/modals/rx';
import SpecialNoteModal from '../../components/doctors/modals/specialNote';
import TemplateModal from '../../components/doctors/modals/templateModal';
import DynamicPrescriptionItemModal from '../../components/doctors/modals/dynamicPrescriptionItemModal';
import TreatmentPlanModal from '../../components/doctors/modals/treatmentPlan';
import VideoCallModal from '../../components/doctors/modals/videoCallModal';
import DiagnosisView from '../../components/doctors/partials/diagnosisView';
import Header from '../../components/doctors/partials/Header';
import PrescriptionSaveBtns from '../../components/doctors/partials/prescriptionSaveBtns';
import RxView from '../../components/doctors/partials/rxView';
import AdviceView from '../../components/doctors/partials/views/advice';
import BarcodeQrCode from '../../components/doctors/partials/views/barcodeQrCode';
import ChiefComplainView from '../../components/doctors/partials/views/chiefComplain';
import EyeGlassView from '../../components/doctors/partials/views/eyeGlassView';
import FollowUpView from '../../components/doctors/partials/views/followUp';
import HistoryView from '../../components/doctors/partials/views/historyView';
import InfertilityView from '../../components/doctors/partials/views/infertility';
import InvestigationView from '../../components/doctors/partials/views/investigation';
import OnExaminationView from '../../components/doctors/partials/views/onExamination';
import PredictionsView from '../../components/doctors/partials/views/predictions';
import ReferredtoView from '../../components/doctors/partials/views/referredto';
import RehabilitationView from '../../components/doctors/partials/views/rehabilitationView';
import SignatureView from '../../components/doctors/partials/views/signatureView';
import SpecialNoteView from '../../components/doctors/partials/views/specialNoteView';
import DynamicPrescriptionItemView from '../../components/doctors/partials/views/dynamicPrescriptionItem';
import TreatmentPlanView from '../../components/doctors/partials/views/treatmentPlan';
import PatientSection from '../../components/doctors/patientSection';
import PrescriptionFooter from '../../components/doctors/prescriptionFooter';
import PrescriptionHeader from '../../components/doctors/prescriptionHeader';
import PrescriptionTop from '../../components/doctors/prescriptionTop';
import { DiagnosisContext } from '../../contexts/DiagnosisContext';
import { HistoryContext } from '../../contexts/HistoryContext';
import { PrescriptionTopContext } from '../../contexts/PrescriptionTopContext';
import { RxContext } from '../../contexts/RxContext';
import { useGetRequest } from '../../hooks/useGetRequest';
import loadingImg from '../../img/saved.gif';
import { onExaminationData } from '../../pages/doctor/onExaminationData';
import { EYE_EXAM_ITEMS } from '../../components/doctors/partials/eyeExamination';
import {
  itemElementNotes,
  setShowMedicineName as setShowMedicineNameAction,
} from '../../store/slices/prescriptionSlice';
import {
  getRequest,
  patchRequest,
  postRequest,
} from '../../utils/axiosRequests';
import {
  ageConvertToDateTime,
  checkDoctorDept,
  getPatientIdForDoctor,
  handleGroupData,
  isExistAnyEyeGlass,
  isExistAnyHistory,
  isExistAnyInfertilityData,
  isExistAnyOnExamination,
  isExistAnyRehabData,
  leftOrRightItems,
  leftSidePrintStyle,
  pagePrintStyle,
  rightSidePrintStyle,
} from '../../utils/helpers';

function Prescription() {
  const printRef = useRef(null);
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.authReducer.data);
  const specialties = useSelector(
    (state) => state.specialtyReducer.specialties,
  );
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  const header = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.header,
  );
  const footer = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.footer,
  );
  const prescriptionSetting = useSelector(
    (state) =>
      state?.prescriptionReducer?.prescriptionInfo?.prescriptionSettings,
  );
  const isPad = prescriptionSetting?.isPadPrescription;
  const prescriptionItems = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.prescriptionItems,
  );
  const allItemElementNotes = useSelector(
    (state) =>
      state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || [],
  );
  const [printStatus, setPrintStatus] = useState(false);
  const location = useLocation();
  const [templateId, setTemplateId] = useState('');
  const [templateName, setTemplateName] = useState('');
  const [isComplainModal, setIsComplainModal] = useState(false);
  const [isReferredToModal, setIsReferredToModal] = useState(false);
  const [isTreatmentPlanModal, setIsTreatmentPlanModal] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [note, setNote] = useState('');
  const [isTemplateModal, setIsTemplateModal] = useState(false);
  const [showOnExamination, setShowOnExamination] = useState(false);
  const [showPredictions, setShowPredictions] = useState(false);
  const [showDiagnosis, setShowDiagnosis] = useState(false);
  const [showInvestigation, setShowInvestigation] = useState(false);
  const [showAdvice, setShowAdvice] = useState(false);
  const [showSpecialNote, setShowSpecialNote] = useState(false);
  const [showInfertility, setShowInfertility] = useState(false);
  const [showRehabilitation, setShowRehabilitation] = useState(false);
  const [showEyeGlass, setShowEyeGlass] = useState(false);
  const [showFollowUp, setShowFollowUp] = useState(false);
  const [showRx, setShowRx] = useState(false);
  const [instructions, setInstructions] = useState([]);
  const [selectedChiefComplains, setSelectedChiefComplains] = useState([]);
  const [selectedComplainGroups, setSelectedComplainGroups] = useState([]);
  const [selectedAdvices, setSelectedAdvices] = useState([]);
  const [selectedSpecialNotes, setSelectedSpecialNotes] = useState([]);
  const [selectedAdvicesGroups, setSelectedAdvicesGroups] = useState([]);
  const [selectedInfertilities, setSelectedInfertilities] = useState({});
  const [selectedTreatmentPlans, setSelectedTreatmentPlans] = useState([]);
  const [selectedTreatmentPlansGroups, setSelectedTreatmentPlansGroups] =
    useState([]);
  const [selectedDynamicItems, setSelectedDynamicItems] = useState({});
  const [selectedDynamicGroups, setSelectedDynamicGroups] = useState({});
  const [dynamicItemModalName, setDynamicItemModalName] = useState('');
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [selectedHistoryTab, setSelectedHistoryTab] = useState(
    userInfo?.email === 'bnasrin.bsmmu@gmail.com' ? 'gynecology' : 'medical',
  );
  const [selectedDiagnosisTab, setSelectedDiagnosisTab] = useState('all');
  const [selectedOnExaminationTab, setSelectedOnExaminationTab] =
    useState('observation');
  const [selectedInfertilityWomenGroups, setSelectedInfertilityWomenGroups] =
    useState([]);
  const [selectedInfertilityManGroups, setSelectedInfertilityManGroups] =
    useState([]);
  const [selectedRehabilitation, setSelectedRehabilitation] = useState({
    orthoses: [],
    exercises: [],
    physicalTherapies: [],
  });
  const [selectedFollowUps, setSelectedFollowUps] = useState([]);
  const [selectedEyeGlass, setSelectedEyeGlass] = useState({
    isPlano: false,
    leftPlano: false,
    rightPlano: false,
    r: { sph: '', cyl: '', axis: '' },
    l: { sph: '', cyl: '', axis: '' },
    remarks: [],
  });
  const [selectedDiagnosisGroups, setSelectedDiagnosisGroups] = useState([]);
  const [selectedInvestigations, setSelectedInvestigations] = useState([]);
  const [selectedInvestigationGroups, setSelectedInvestigationGroups] =
    useState([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState([]);
  const [selectedReferredto, setSelectedReferredto] = useState([]);
  const [selectedReferredtoGroups, setSelectedReferredtoGroups] = useState([]);
  const [selectedStage, setSelectedStage] = useState({});
  const [selectedHistories, setSelectedHistories] = useState({});
  const [selectedOnExamination, setSelectedOnExamination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [appointmentStatus, setAppointmentStatus] = useState(false);
  const [editMedicineId, setEditMedicineId] = useState('');
  ///////////////////Medicine related/////////////////////////
  const perPage = 25;
  const [totalItem, setTotalItem] = useState(0);
  const [medicines, setMedicines] = useState([]);
  const [medicinesInSearch, setMedicinesInSearch] = useState([]);
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const [interactionData, setInteractionData] = useState({});
  const [acknowledgedPairs, setAcknowledgedPairs] = useState(new Set());
  const [selectedMedicineGroups, setSelectedMedicineGroups] = useState([]);
  const [medicineGroups, setMedicineGroups] = useState([]);
  //////////////////////////attachments///////////////////////////
  const [title, setTitle] = useState('');
  const [files, setFiles] = useState([]);
  ////////////////////////////////////////////////////////
  const [patientList, setPatientList] = useState([]);
  const [errors, setErrors] = useState({});
  const [prescriptionId, setPrescriptionId] = useState('');
  const [prescriptionIdForCode, setPrescriptionIdForCode] = useState('');
  const [appointmentDateTime, setAppointmentDateTime] = useState('');
  const [editDob, setEditDob] = useState(null);
  const [patientPicture, setPatientPicture] = useState(null);
  const [hideItems, setHideItems] = useState({});
  const showMedicineName = useSelector(
    (state) => state.prescriptionReducer.prescriptionInfo.showMedicineName,
  );
  const [medicineType, setMedicineType] = useState('');
  const setShowMedicineName = (val) => dispatch(setShowMedicineNameAction(val));

  const isGyne = checkDoctorDept(
    'gynecology',
    userInfo?.speciality[0],
    specialties,
  );

  const [patientInfo, setPatientInfo] = useState({
    id: '',
    name: '',
    dob: {
      years: '',
      months: '',
      days: '',
      hours: '',
    },
    phoneNumber: '',
    gender: isGyne ? 'female' : 'male',
    status: 'created',
    nid: '',
    patientId: '',
    doctorId: userInfo.id,
    email: '',
    patientDetails: {},
    organizationId: activeOrganization.id,
  });
  const [appointmentInfo, setAppointmentInfo] = useState({
    id: '',
    patientId: '',
    status: '',
    appointmentDateTime: '',
    organizationId: activeOrganization.id,
  });

  //for video calling
  // const socket = io('localhost:3009');
  let socket = null;
  if (userInfo?.doctorDetails?.isVideoCall) {
    // socket = io('localhost:3009');
    // socket = io('http://localhost:3009');
  }
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [onlineUserExist, setOnlineUserExist] = useState(false);
  const [startCalling, setStartCalling] = useState(1);
  const [startVideo, setStartVideo] = useState(0);
  const [callTimeoutHandler, setCallTimeoutHandler] = useState(null);
  const [shouldClearTimeout, setShouldClearTimeout] = useState(false);
  const [roomName, setRoomName] = useState('');

  const cancelCall = () => {
    setStartCalling(0);
    setStartVideo(0);
    setShouldClearTimeout(true);
    setOpenVideoModal(false);
  };

  useEffect(() => {
    // client-side
    if (socket) {
      if (socket && socket.connected) {
        console.log('socket conneted1 ', socket.id);
        // if(userInfo?.id && userInfo?.id !== 'doctor'){
        socket.emit('setUsername', userInfo.id);
        // }
        // if (patientInfo.id) {
        socket.emit('checkUsername', patientInfo.id);
        // }
      }
      socket.on('connect', () => {
        console.log('socket connected ', socket.id); // x8WIv7-mJelg7on_ALbx
        socket.emit('setUsername', userInfo.id);
        socket.emit('checkUsername', patientInfo.id);
      });

      socket.on('privateMessage', (data) => {
        console.log('message from cleint ', data);
        const message = data;
        console.log('come from data ', message);
        if (message?.type === 'confirm_startCall') {
          console.log('updating startvideo status');
          setStartVideo(1);
        } else if (message?.type === 'endCall') {
        }
      });

      socket.on('checkUsername', (data) => {
        console.log('checking online patient');
        if (data?.username === patientInfo.id && data?.userOnline) {
          setOnlineUserExist(true);
        } else {
          setOnlineUserExist(false);
        }
      });

      socket.on('disconnect', () => {
        console.log('disconnected ', socket.id); // undefined
      });
    }
  }, [patientInfo]);

  if (socket && socket.connected) {
    socket.on('checkUsername', (data) => {
      // console.log('checking online patient', data, patientInfo);
      if (data?.username === patientInfo.id && data?.userOnline) {
        setOnlineUserExist(true);
      } else {
        setOnlineUserExist(false);
      }
    });

    socket.on('disconnect', () => {
      console.log('disconnected ', socket.id); // undefined
    });
  }

  const rxItemName = (itemName) => {
    if (prescriptionItems && prescriptionItems?.items) {
      const itemNames = {
        'chief-complain': 'Chief Complain',
        history: 'History',
        diagnosis: 'Diagnosis',
        'on-examination': 'On Examinations',
        investigation: 'Investigations',
        rx: 'Rx',
        rehabilitation: 'Rehabilitation',
        'follow-up': 'Follow-Up',
        advice: 'Advice',
        infertility: 'Infertility',
        'eye-glass': 'Eye-Glass',
        'special-note': 'Special Note',
        signature: 'Signature',
        predictions: 'Predictions',
        referredto: 'Referred To',
        'treatment-plan': 'Treatment To',
      };
      const item = prescriptionItems?.items[itemName];
      return item?.alterName ? item.alterName : itemNames[itemName];
    } else {
      return '';
    }
  };

  const resetPrescription = (templateSelect = false) => {
    setHideItems(null);
    setSelectedTemplates([]);
    setSelectedChiefComplains([]);
    setSelectedTreatmentPlans([]);
    setSelectedReferredto([]);
    setSelectedComplainGroups([]);
    setSelectedDiagnosis([]);
    setSelectedStage({});
    setSelectedDiagnosisGroups([]);
    setSelectedAdvices([]);
    setSelectedAdvicesGroups([]);
    setSelectedFollowUps([]);
    setSelectedMedicines([]);
    setSelectedMedicineGroups([]);
    setSelectedInvestigations([]);
    setSelectedInvestigationGroups([]);
    setSelectedInfertilities({});
    setSelectedInfertilityManGroups([]);
    setSelectedInfertilityWomenGroups([]);
    setSelectedSpecialNotes([]);
    setSelectedHistoryTab(
      userInfo?.email === 'bnasrin.bsmmu@gmail.com' ? 'gynecology' : 'medical',
    );
    setSelectedEyeGlass({
      isPlano: false,
      leftPlano: false,
      r: { sph: '', cyl: '', axis: '' },
      l: { sph: '', cyl: '', axis: '' },
      remarks: [],
    });
    setSelectedRehabilitation({
      orthoses: [],
      exercises: [],
      physicalTherapies: [],
    });
    setSelectedHistories({});
    setSelectedOnExamination({});
    setSelectedDynamicItems({});
    setSelectedDynamicGroups({});
    if (!templateSelect) {
      setPatientInfo({
        ...patientInfo,
        id: '',
        name: '',
        dob: {},
        phoneNumber: '',
        gender: isGyne ? 'female' : 'male',
        status: 'created',
        nid: '',
        patientId: '',
        email: '',
        doctorId: userInfo.id,
        organizationId: activeOrganization.id,
        image: null,
        patientDetails: {},
      });
    }
    setAppointmentInfo({
      id: '',
      patientId: '',
      status: '',
      appointmentDateTime: '',
      organizationId: activeOrganization.id,
      reset: false,
    });
    setPrescriptionId('');
    setPatientPicture(null);
    setEditDob(null);
  };

  const footerHeightStr =
    prescriptionSetting?.footer?.height?.quantity != null
      ? `${prescriptionSetting.footer.height.quantity}${prescriptionSetting.footer.height.unit ?? 'px'}`
      : null;

  const computedPageStyle =
    [
      footerHeightStr
        ? `@page { margin: 0; margin-bottom: ${footerHeightStr}; }`
        : '',
      `@media print { body { -webkit-print-color-adjust: exact; color-adjust: exact; print-color-adjust: exact; } }`,
      isPad && footerHeightStr
        ? `.pad-footer-spacer { display: none !important; }`
        : '',
    ]
      .filter(Boolean)
      .join('\n') || undefined;

  const callbackPrint = useReactToPrint({
    content: () => printRef.current,
    ...(computedPageStyle ? { pageStyle: computedPageStyle } : {}),
  });

  const settingPatientData = (patient) => {
    let dob = patient.dob;
    const utcMoment = moment.utc(dob);
    const localMoment = utcMoment.local();
    const formattedLocalTime = localMoment.format('YYYY-MM-DD HH:mm:ss');
    setPatientInfo({
      ...patientInfo,
      id: patient?.id,
      name: patient?.name,
      dob: formattedLocalTime,
      gender: patient?.gender?.toLowerCase() || patientInfo.gender,
      phoneNumber: patient?.phoneNumber,
      email: patient?.email,
      patientDetails: patient?.patientDetails,
      patientId: getPatientIdForDoctor(patient?.patientIdForDoctor, userInfo),
    });
  };

  useEffect(() => {
    const history = location?.state?.history;
    const appointment = location?.state?.appointment;
    setEditDob(location?.state?.dob);
    if (history === 'editFromHistory' || history === 'editFromPatientList') {
      let patientHistory = location?.state?.prescription;
      console.log(
        'patientHistory: ============+++++++++++++++++++++++++',
        patientHistory,
      );
      let patientData = patientHistory?.patientId;
      patientData.dob = patientData?.dob;
      if (history === 'editFromPatientList') {
        patientData.gender =
          patientData.gender || location?.state?.patientGender;
      }
      console.log(
        'editFromPatientList — patientData.gender:',
        patientData.gender,
      );
      settingPatientData(patientData);
      setNote(location?.state?.note);

      let otherDetails = {};
      if (history === 'editFromHistory') {
        const existingData = patientHistory?.appointmentId?.otherDetails;
        otherDetails = {
          ...otherDetails,
          reference_by: existingData?.reference_by,
          disease: existingData?.disease,
          date_of_admission: existingData?.date_of_admission,
          date_of_discharge: existingData?.date_of_discharge,
        };
      }
      if (history === 'editFromPatientList') {
        const existingData = patientHistory?.appointmentId?.otherDetails;
        otherDetails = {
          ...otherDetails,
          reference_by: existingData?.reference_by,
          disease: existingData?.disease,
        };
      }
      if (appointment) {
        setAppointmentInfo({ ...appointment, status: 'completed' });
      } else {
        setAppointmentInfo({
          id: patientHistory?.appointmentId?.id,
          patientId: patientHistory?.patientId?.id,
          status: 'completed',
          appointmentDateTime:
            patientHistory?.appointmentId?.appointmentDateTime,
          organizationId: activeOrganization.id,
          otherDetails: otherDetails,
        });
      }

      setPrescriptionId(patientHistory.id);
      setPrescriptionIdForCode(location?.state?.prescriptionId);
      // setPrescriptionId(
      //   history === 'editFromPatientList'
      //     ? location?.state?.prescriptionId
      //     : patientHistory.id,
      // );

      // setAppointmentDateTime(
      //   patientHistory?.appointmentId?.appointmentDateTime,
      // );
      patientHistory?.chiefComplains
        ? setSelectedChiefComplains([...patientHistory?.chiefComplains])
        : setSelectedChiefComplains([]);
      patientHistory?.referredto
        ? setSelectedReferredto([...patientHistory?.referredto])
        : setSelectedReferredto([]);
      patientHistory?.treatmentPlans
        ? setSelectedTreatmentPlans([...patientHistory?.treatmentPlans])
        : setSelectedTreatmentPlans([]);
      patientHistory?.diagnoses
        ? setSelectedDiagnosis([...patientHistory?.diagnoses])
        : setSelectedDiagnosis([]);
      patientHistory?.staging
        ? setSelectedStage({ ...patientHistory?.staging })
        : setSelectedStage({});
      patientHistory?.advices
        ? setSelectedAdvices([...patientHistory?.advices])
        : setSelectedAdvices([]);
      patientHistory?.followUps
        ? setSelectedFollowUps([...patientHistory?.followUps])
        : setSelectedFollowUps([]);
      setSelectedMedicines([...patientHistory?.medicines]);
      patientHistory?.histories
        ? setSelectedHistories({ ...patientHistory?.histories })
        : setSelectedHistories({});
      patientHistory?.onExaminations
        ? setSelectedOnExamination({ ...patientHistory?.onExaminations })
        : setSelectedOnExamination({});
      patientHistory?.investigations
        ? setSelectedInvestigations([...patientHistory?.investigations])
        : setSelectedInvestigations([]);
      patientHistory?.eyeGlass
        ? setSelectedEyeGlass({ ...patientHistory?.eyeGlass })
        : setSelectedEyeGlass({
            isPlano: false,
            leftPlano: false,
            rightPlano: false,
            r: { sph: '', cyl: '', axis: '' },
            l: { sph: '', cyl: '', axis: '' },
            remarks: [],
          });
      patientHistory?.infertilities
        ? setSelectedInfertilities({ ...patientHistory?.infertilities })
        : setSelectedInfertilities({});
      patientHistory?.rehabilitation
        ? setSelectedRehabilitation({ ...patientHistory?.rehabilitation })
        : setSelectedRehabilitation({});
      patientHistory?.specialNotes
        ? setSelectedSpecialNotes([...patientHistory?.specialNotes])
        : setSelectedSpecialNotes([]);
      const rehabData = patientHistory?.rehabilitation
        ? patientHistory.rehabilitation
        : selectedRehabilitation;
      setSelectedRehabilitation({ ...rehabData });
      patientHistory?.dynamicItems &&
      Object.keys(patientHistory.dynamicItems).length > 0
        ? setSelectedDynamicItems({ ...patientHistory.dynamicItems })
        : setSelectedDynamicItems({});
    } else if (history === 'editFromList') {
      let appointmentData = location?.state?.appointmentInfo;
      let patientData = appointmentData?.patientId;
      //patientData.dob = patientData?.dob;
      settingPatientData(patientData);

      setAppointmentInfo({
        id: appointmentData?.id,
        patientId: appointmentData?.patientId?.id,
        status: 'completed',
        appointmentDateTime: appointmentData?.appointmentDateTime,
        organizationId: activeOrganization.id,
      });
      setAppointmentDateTime(appointmentData?.appointmentDateTime);
    } else if (history === 'new') {
      const patInfo = location?.state?.patientData;
      const utcMoment = moment.utc(patInfo?.dob);
      const localMoment = utcMoment.local();
      const formattedLocalTime = localMoment.format('YYYY-MM-DD HH:mm:ss');
      const patentModifiedInfo = {
        id: patInfo?.id,
        email: patInfo?.email,
        name: patInfo?.name,
        phoneNumber: patInfo?.phoneNumber,
        gender: patInfo?.gender?.toLowerCase() || 'male',
        dob: formattedLocalTime,
        patientDetails: patInfo?.patientDetails,
      };
      setPatientInfo({
        ...patentModifiedInfo,
        status: 'created',
        doctorId: userInfo.id,
        organizationId: activeOrganization.id,
      });
      // OLD CODE
      // setPatientInfo({
      //   ...location?.state?.patientData,
      //   dob: location?.state?.patientData?.dob,
      //   status: 'created',
      //   doctorId: userInfo.id,
      //   organizationId: activeOrganization.id,
      // });
    } else if (history === 'completed') {
      let appointment = location?.state?.appointmentInfo;
      let patientData = appointment?.patientId;
      patientData.dob = patientData?.dob;
      settingPatientData(patientData);

      setAppointmentInfo({
        ...appointmentInfo,
        id: appointment.id,
        patientId: appointment.patientId.id,
        status: appointment.status,
        appointmentDateTime: appointment.appointmentDateTime,
      });
    } else if (history === 'onlyAppointment') {
      let appointment = location?.state?.appointment;
      let patientData = appointment?.patientId;
      //patientData.dob = patientData?.dob;
      settingPatientData(patientData);
      appointmentInfo.id = appointment?.id;
      appointmentInfo.patientId = appointment?.patientId.id;
      appointmentInfo.status = appointment?.status;
      appointmentInfo.appointmentDateTime = appointment?.appointmentDateTime;
      setAppointmentInfo({ ...appointmentInfo });
      if (appointment?.otherDetails?.generalExaminations) {
        setSelectedOnExamination({
          ...selectedOnExamination,
          generalExaminations: appointment?.otherDetails?.generalExaminations,
        });
      }
      if (appointment?.otherDetails?.chiefComplains?.length) {
        setSelectedChiefComplains(appointment?.otherDetails?.chiefComplains);
      }
      if (appointment?.otherDetails?.investigations?.length) {
        setSelectedInvestigations(appointment?.otherDetails?.investigations);
      }
    } else if (history === 'fromReset') {
      setTemplateId(location?.state?.templateData?.id);
      setTemplateName(location?.state?.templateData?.name);
      setPrescriptionData(location?.state?.templateData);
    }

    // for hide and show print on run time
    const hideItemsLocalData = localStorage.getItem('hidePrescriptionItems');
    const hideItemsLocal = hideItemsLocalData
      ? JSON.parse(hideItemsLocalData)
      : { 'patient-section': false };
    setHideItems({ ...hideItemsLocal });
    //End for hide and show print on run time
  }, []);

  useEffect(() => {
    if (patientInfo?.search === 'yes') {
      setSelectedChiefComplains([]);
      setSelectedTreatmentPlans([]);
      setSelectedReferredto([]);
      setSelectedDiagnosis([]);
      setSelectedStage({});
      setSelectedMedicines([]);
      setSelectedAdvices([]);
      setSelectedFollowUps([]);
      setSelectedEyeGlass({
        isPlano: false,
        leftPlano: false,
        r: { sph: '', cyl: '', axis: '' },
        l: { sph: '', cyl: '', axis: '' },
        remarks: [],
      });
      setSelectedRehabilitation({
        orthoses: [],
        exercises: [],
        physicalTherapies: [],
      });
      setSelectedHistories({});
      setSelectedOnExamination(onExaminationData);
      setSelectedInvestigations([]);
      // get last prescription info
      if (patientInfo?.id !== '') {
        getPatientPrescriptionLast();
      }
    }
  }, [patientInfo]);

  useEffect(() => {
    if (
      location?.state?.appointmentInfo?.id &&
      location?.state?.appointmentInfo?.patientId?.id &&
      appointmentInfo?.reset !== false
    ) {
      getPatientAppointmentAndPrescription();
    }
  }, [appointmentInfo]);

  const { isLoading: isMedicineLoading, refetch: getMedicineList } =
    useGetRequest(
      'getMedicines',
      `medicines?page=${currentPage}&perPage=${perPage}`,
      (data) => {
        console.log('napa');
        if (currentPage > 1) {
          setMedicines([...medicines, ...data.data]);
        } else {
          setMedicines(data.data);
          setTotalItem(data.total);
        }
      },
      (e) => {
        console.log(e);
      },
    );

  const { isLoading: isInstructionLoading, refetch: getInstructionList } =
    useGetRequest(
      'instructionList',
      `instructions`,
      (data) => {
        setInstructions(data.data);
      },
      (e) => {
        console.log(e);
      },
    );

  const { isLoading: isMedGrpLoading, refetch: getMedGrpList } = useGetRequest(
    'med-grp-list',
    `prescriptions/groups?organizationId=${activeOrganization.id}`,
    (data) => {
      setMedicineGroups(data);
    },
    (e) => {
      console.log(e);
    },
  );

  const {
    isLoading: isPatientPictureLoading,
    refetch: getPatientProfilePicture,
  } = useGetRequest(
    'get-patient-img',
    `auth/patient-picture/${patientInfo?.id}`,
    (data) => {
      setPatientPicture(data);
    },
    (e) => {
      console.log('error message: ', e.message);
    },
  );

  useEffect(() => {
    if (patientInfo?.id) {
      getPatientProfilePicture();
    }
  }, [patientInfo?.id]);

  useEffect(() => {
    getInstructionList();
    getMedGrpList();
  }, []);

  useEffect(() => {
    getMedicineList();
  }, [currentPage]);

  useEffect(() => {
    const medicines = selectedMedicines.filter((m) => m.genericName);
    if (medicines.length < 2) {
      setInteractionData({});
      return;
    }

    const normStr = (s) => (s || '').toLowerCase().trim();
    const sameGeneric = (a, b) => {
      const na = normStr(a);
      const nb = normStr(b);
      return na === nb || na.includes(nb) || nb.includes(na);
    };

    // Collect all unique query parts (split compound names like "A + B")
    const allParts = [
      ...new Set(
        medicines.flatMap((med) =>
          med.genericName
            .split('+')
            .map((s) => s.trim())
            .filter(Boolean),
        ),
      ),
    ];

    // Fetch interactions for every part in parallel
    Promise.all(
      allParts.map((part) =>
        getRequest(
          `medicine-interactions/by-generic-name/${encodeURIComponent(part)}`,
        )
          .then((res) => res?.data || [])
          .catch(() => []),
      ),
    ).then((results) => {
      // Deduplicate by id
      const seen = new Set();
      const allRecords = results.flat().filter((r) => {
        const key = r.id || `${r.genericName}|${r.genericNameInteraction}|${r.level}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      // Distribute each record to BOTH medicines involved so icons appear on both sides
      const newData = {};
      medicines.forEach((med) => {
        newData[med.genericName] = allRecords.filter(
          (r) =>
            sameGeneric(r.genericName, med.genericName) ||
            sameGeneric(r.genericNameInteraction, med.genericName),
        );
      });
      setInteractionData(newData);
    });
  }, [selectedMedicines.map((m) => m.genericName).filter(Boolean).sort().join(',')]);

  const handleAcknowledgeInteraction = (pairKeys, records = []) => {
    setAcknowledgedPairs((prev) => {
      const next = new Set(prev);
      pairKeys.forEach((k) => next.add(k));
      return next;
    });

    if (!records.length) return;
    const normStr = (s) => (s || '').toLowerCase().trim();
    // Remove the acknowledged records from every medicine's interaction list
    // so both sides of the pair lose the icon immediately
    setInteractionData((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((medName) => {
        next[medName] = (next[medName] || []).filter(
          (r) =>
            !records.some(
              (rec) =>
                normStr(rec.genericName) === normStr(r.genericName) &&
                normStr(rec.genericNameInteraction) === normStr(r.genericNameInteraction) &&
                normStr(rec.level) === normStr(r.level),
            ),
        );
      });
      return next;
    });
  };

  const handlePrintStatus = (status) => {
    setPrintStatus(status);
  };
  const closeOnExaminationModal = () => {
    setShowOnExamination(false);
  };
  const handleOnExaminations = (selectedOnExaminations) => {
    setSelectedOnExamination({ ...selectedOnExaminations });
  };

  const unSelectTemplate = (data) => {
    if (data?.medicines?.length > 0) {
      let itemsToDelete = data?.medicines?.map((item) => item.id);
      setSelectedMedicines((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.id)),
      );
    }
    if (data?.chiefComplains?.length > 0) {
      let itemsToDelete = data?.chiefComplains?.map((item) => item.name);
      setSelectedChiefComplains((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    if (data?.referredto?.length > 0) {
      let itemsToDelete = data?.referredto?.map((item) => item.name);
      setSelectedReferredto((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    if (data?.treatmentPlans?.length > 0) {
      let itemsToDelete = data?.treatmentPlans?.map((item) => item.name);
      setSelectedTreatmentPlans((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    if (
      data?.rehabilitation?.physicalTherapies?.length > 0 ||
      data?.rehabilitation?.exercises?.length > 0 ||
      data?.rehabilitation?.orthoses?.length > 0
    ) {
      setSelectedRehabilitation({
        orthoses: [],
        exercises: [],
        physicalTherapies: [],
      });
    }
    if (data?.diagnoses?.length > 0) {
      let itemsToDelete = data?.diagnoses?.map((item) => item.name);
      setSelectedDiagnosis((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    if (data?.investigations?.length > 0) {
      let itemsToDelete = data?.investigations?.map((item) => item.name);
      setSelectedInvestigations((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    if (data?.advices?.length > 0) {
      let itemsToDelete = data?.advices?.map((item) => item.name);
      setSelectedAdvices((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    if (data?.followUps?.length > 0) {
      let itemsToDelete = data?.followUps?.map((item) => item.name);
      setSelectedFollowUps((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    if (data?.specialNotes?.length > 0) {
      let itemsToDelete = data?.specialNotes?.map((item) => item.name);
      setSelectedSpecialNotes((prevItems) =>
        prevItems.filter((item) => !itemsToDelete.includes(item.name)),
      );
    }
    data?.histories && Object.keys(data?.histories).length === 0
      ? setSelectedHistories(selectedHistories)
      : setSelectedHistories({});
    data?.onExaminations && Object.keys(data?.onExaminations).length === 0
      ? setSelectedOnExamination(selectedOnExamination)
      : setSelectedOnExamination({});
    // data?.infertilities && Object.keys(data?.infertilities).length === 0
    //   ? setSelectedInfertilities(selectedInfertilities)
    //   : setSelectedInfertilities({});
    data?.eyeGlass && Object.keys(data?.eyeGlass).length === 0
      ? setSelectedEyeGlass(selectedEyeGlass)
      : setSelectedEyeGlass({
          isPlano: false,
          leftPlano: false,
          rightPlano: false,
          r: { sph: '', cyl: '', axis: '' },
          l: { sph: '', cyl: '', axis: '' },
          remarks: [],
        });
    data?.rehabilitation && Object.keys(data?.rehabilitation).length === 0
      ? setSelectedRehabilitation(selectedRehabilitation)
      : setSelectedRehabilitation({});
  };

  const toggleTemplateSelection = (selectedItem) => {
    const type = selectedItem?.type;
    switch (type) {
      case 'Prescription Template':
        if (!templateId) {
          setTemplateId(selectedItem?.id);
          setTemplateName(selectedItem?.name);
        }
        if (selectedTemplates?.some((item) => item.id === selectedItem.id)) {
          setSelectedTemplates(
            selectedTemplates?.filter((item) => item.id !== selectedItem.id),
          );
          if (selectedTemplates?.length === 1) {
            setTemplateId('');
            setTemplateName('');
          }
          unSelectTemplate(selectedItem);
        } else {
          setSelectedTemplates([...selectedTemplates, selectedItem]);
          setPrescriptionData(selectedItem);
        }
        break;
      case 'Diagnosis group':
        handleGroupData(
          selectedItem,
          selectedDiagnosisGroups,
          setSelectedDiagnosisGroups,
          selectedDiagnosis,
          setSelectedDiagnosis,
          type,
        );
        break;
      case 'Referredto group':
        handleGroupData(
          selectedItem,
          selectedReferredtoGroups,
          setSelectedReferredtoGroups,
          selectedReferredto,
          setSelectedReferredto,
          type,
        );
        break;
      case 'Chief complain group':
        handleGroupData(
          selectedItem,
          selectedComplainGroups,
          setSelectedComplainGroups,
          selectedChiefComplains,
          setSelectedChiefComplains,
          type,
        );
        break;
      case 'Medicine group':
        if (
          selectedMedicineGroups?.some((item) => item.id === selectedItem.id)
        ) {
          unSelectMedicineGroup(selectedItem);
        } else {
          selectMedicineGroup(selectedItem);
        }
        break;
      case 'Investigation group':
        handleGroupData(
          selectedItem,
          selectedInvestigationGroups,
          setSelectedInvestigationGroups,
          selectedInvestigations,
          setSelectedInvestigations,
          type,
        );
        break;
      case 'Advice group':
        handleGroupData(
          selectedItem,
          selectedAdvicesGroups,
          setSelectedAdvicesGroups,
          selectedAdvices,
          setSelectedAdvices,
          type,
        );
        break;
      case 'Patient':
        setPatientInfo({
          ...patientInfo,
          id: selectedItem?.id,
          name: selectedItem?.name,
          dob: selectedItem?.dob,
          phoneNumber: selectedItem?.phoneNumber,
          search: 'yes',
          email: selectedItem?.email,
        });
        break;
      default:
    }
  };

  const selectMedicineGroup = (medicineGroup) => {
    const newMedicines = medicineGroup?.medicines?.filter(
      (medicine) => !selectedMedicines.some((data) => data.id === medicine.id),
    );
    setSelectedMedicines([...selectedMedicines, ...newMedicines]);
    setSelectedMedicineGroups([...selectedMedicineGroups, medicineGroup]);
  };

  const unSelectMedicineGroup = (medicineGroup) => {
    const otherGroups = selectedMedicineGroups.filter(
      (data) => data.name !== medicineGroup.name,
    );
    setSelectedMedicineGroups([...otherGroups]);
    let itemsToDelete = medicineGroup?.medicines?.map((item) => item.id);
    if (otherGroups?.length) {
      const otherGroupItems = otherGroups.flatMap((obj) =>
        obj?.medicines?.map((item) => item.id),
      );
      itemsToDelete = itemsToDelete.filter(
        (item) => !otherGroupItems?.includes(item),
      );
    }
    setSelectedMedicines((prevItems) =>
      prevItems.filter((item) => !itemsToDelete.includes(item.id)),
    );
  };

  const removeDuplicateItem = (items) => {
    return items.reduce((acc, curr) => {
      if (!acc.some((item) => item.name === curr.name)) {
        acc.push(curr);
      }
      return acc;
    }, []);
  };

  const setPrescriptionData = (prescription) => {
    const chiefComplains = prescription?.chiefComplains?.length
      ? removeDuplicateItem([
          ...selectedChiefComplains,
          ...prescription.chiefComplains,
        ])
      : selectedChiefComplains;
    setSelectedChiefComplains(chiefComplains);

    const treatmentPlans = prescription?.treatmentPlans?.length
      ? removeDuplicateItem([
          ...selectedTreatmentPlans,
          ...prescription.treatmentPlans,
        ])
      : selectedTreatmentPlans;
    setSelectedTreatmentPlans(treatmentPlans);

    const referredto = prescription?.referredto?.length
      ? removeDuplicateItem([...selectedReferredto, ...prescription.referredto])
      : selectedReferredto;
    setSelectedReferredto(referredto);

    const diagnoses = prescription?.diagnoses?.length
      ? removeDuplicateItem([...selectedDiagnosis, ...prescription.diagnoses])
      : selectedDiagnosis;
    setSelectedDiagnosis(diagnoses);

    const advices = prescription?.advices?.length
      ? removeDuplicateItem([...selectedAdvices, ...prescription.advices])
      : selectedAdvices;
    setSelectedAdvices(advices);

    const followUps = prescription?.followUps?.length
      ? [...new Set([...selectedFollowUps, ...prescription.followUps])]
      : selectedFollowUps;
    setSelectedFollowUps(followUps);

    const medicines = prescription?.medicines?.length
      ? removeDuplicateItem([...selectedMedicines, ...prescription.medicines])
      : selectedMedicines;
    setSelectedMedicines(medicines);

    const investigations = prescription?.investigations?.length
      ? removeDuplicateItem([
          ...selectedInvestigations,
          ...prescription.investigations,
        ])
      : selectedInvestigations;
    setSelectedInvestigations(investigations);

    prescription?.histories
      ? setSelectedHistories({ ...prescription?.histories })
      : setSelectedHistories(selectedHistories);

    prescription?.onExaminations
      ? setSelectedOnExamination({ ...prescription?.onExaminations })
      : setSelectedOnExamination(selectedOnExamination);

    prescription?.infertilities
      ? setSelectedInfertilities({ ...prescription?.infertilities })
      : setSelectedInfertilities(selectedInfertilities);

    prescription?.eyeGlass
      ? setSelectedEyeGlass({ ...prescription?.eyeGlass })
      : setSelectedEyeGlass(selectedEyeGlass);
    prescription?.rehabilitation
      ? setSelectedRehabilitation({ ...prescription?.rehabilitation })
      : setSelectedRehabilitation(selectedRehabilitation);
    // prescription?.specialNotes
    //   ? setSelectedSpecialNotes([...prescription?.specialNotes])
    //   : setSelectedSpecialNotes([]);

    // const specialNotes = prescription?.specialNotes?.length
    //   ? removeDuplicateItem([
    //       ...selectedSpecialNotes,
    //       ...prescription?.specialNotes,
    //     ])
    //   : selectedSpecialNotes;

    const specialNotes = prescription?.specialNotes?.length
      ? prescription?.specialNotes
      : selectedSpecialNotes;
    setSelectedSpecialNotes([...specialNotes]);

    if (
      prescription?.dynamicItems &&
      Object.keys(prescription.dynamicItems).length > 0
    ) {
      setSelectedDynamicItems((prev) => ({
        ...prev,
        ...prescription.dynamicItems,
      }));
    }
    if (
      prescription?.dynamicGroups &&
      Object.keys(prescription.dynamicGroups).length > 0
    ) {
      setSelectedDynamicGroups((prev) => ({
        ...prev,
        ...prescription.dynamicGroups,
      }));
    }

    if (prescription?.medicineType) {
      setMedicineType(prescription?.medicineType);
    }
  };

  const getPatientPrescriptionLast = () => {
    const url = `prescriptions?organizationId=${activeOrganization.id}&patientId=${patientInfo.id}`;
    getRequest(url)
      .then((data) => {
        let content = data.data;
        let length = content.length;
        if (length) {
          let prescription =
            length > 0 ? (length === 1 ? content[0] : content[length - 1]) : {};
          setPrescriptionId(prescription.id);
          setPrescriptionData(prescription);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const {
    isLoading: isPatientAppointment,
    refetch: getPatientAppointmentAndPrescription,
  } = useGetRequest(
    'getPatientLastPrescription',
    'prescriptions?organizationId=' +
      activeOrganization.id +
      '&appointmentId=' +
      location?.state?.appointmentInfo?.id +
      '&patientId=' +
      location?.state?.appointmentInfo?.patientId?.id,
    (data) => {
      let content = data.data;
      let length = content.length;
      if (length) {
        let prescription =
          length > 0 ? (length === 1 ? content[0] : content[length - 1]) : {};
        setPrescriptionId(prescription?.id);
        setPrescriptionData(prescription);
        setNote(data?.note?.note);
      }
    },
    (error) => {
      console.log(error, 'error');
    },
  );

  const handleSpecialNote = (data) => {
    return data?.map((item) => {
      return {
        groupName: item?.groupName,
        note: item?.note,
      };
    });
  };

  const getPatientDob = () => {
    let dob = '';
    if (patientInfo?.id) {
      dob =
        typeof patientInfo?.dob == 'object'
          ? ageConvertToDateTime(patientInfo?.dob)
          : patientInfo?.dob;
    } else if (patientInfo?.dob && typeof patientInfo?.dob === 'object') {
      dob = ageConvertToDateTime(patientInfo?.dob);
    } else if (patientInfo?.dob && typeof patientInfo?.dob === 'string') {
      dob = patientInfo?.dob;
    } else {
      dob = editDob;
    }
    return dob;
  };

  const handleSubmit = async (submitType) => {
    toast.dismiss();
    setLoadingStatus(true);
    if (
      patientInfo.id === '' ||
      patientInfo.search === 'yes' ||
      patientInfo.status === 'created'
    ) {
      patientInfo.organizationId = activeOrganization.id;
      console.log('dob test1: ', patientInfo.dob);
      patientInfo.dob = getPatientDob();

      console.log('dob test2: ', patientInfo.dob);

      await postRequest('patients', patientInfo)
        .then((data) => {
          patientInfo.dob = data.dob;
          patientInfo.id = data.id;
          patientInfo.patientId = data?.patientId;
          patientInfo.patientIdForDoctor = data?.patientIdForDoctor;
          setEditDob(data.dob);
          settingPatientData(patientInfo);
          appointmentInfo.patientId = data.id;
          setAppointmentInfo({
            ...appointmentInfo,
            reset: false,
          });
        })
        .catch((error) => {
          setLoadingStatus(false);
          const errorMsg = error.message.split(',');
          toast.error(errorMsg[0], {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }

    if (patientInfo.id !== '' && appointmentInfo.status !== 'new') {
      appointmentInfo.status = 'completed';
      appointmentInfo.organizationId = activeOrganization.id;
      appointmentInfo.appointmentDateTime = moment().format('YYYY-MM-DD HH:mm');

      const requestUrl =
        appointmentInfo.id &&
        moment(appointmentDateTime).format('YYYY-MM-DD') ===
          moment().format('YYYY-MM-DD')
          ? patchRequest('appointments/' + appointmentInfo.id, appointmentInfo)
          : postRequest('appointments', appointmentInfo);

      await requestUrl
        .then((data) => {
          appointmentInfo.id = data.id;
          setAppointmentInfo({
            ...appointmentInfo,
            reset: false,
          });
          setAppointmentStatus(data.status);
          setAppointmentDateTime(data.appointmentDateTime);
        })
        .catch((error) => {
          setLoadingStatus(false);
          console.log(error);
        });
    }
    let formData = new FormData();
    if (appointmentInfo.id !== '') {
      let prescriptionArr = {
        patientId: patientInfo.id,
        appointmentId: appointmentInfo.id,
        note: { note },
        organizationId: activeOrganization.id,
        chiefComplains: selectedChiefComplains,
        onExaminations: selectedOnExamination,
        diagnoses: selectedDiagnosis,
        staging: selectedStage,
        histories: selectedHistories,
        medicines: selectedMedicines,
        advices: selectedAdvices,
        rehabilitation: selectedRehabilitation,
        followUps: selectedFollowUps,
        investigations: selectedInvestigations,
        treatmentPlans: selectedTreatmentPlans,
        dynamicItems: selectedDynamicItems,
        dynamicGroups: selectedDynamicGroups,
        referredto: selectedReferredto,
        eyeGlass: selectedEyeGlass,
        infertilities: selectedInfertilities,
        specialNotes: handleSpecialNote(selectedSpecialNotes),
        medicineIds: selectedMedicines.length
          ? selectedMedicines.map((item) => item.id)
          : [],
        medicineType:
          showMedicineName === 'genericName' ? 'genericName' : 'brandName',
        // medicineIds: selectedMedicines.length
        //   ? selectedMedicines.map((item) => item.id)
        //   : [],
        prescriptionItemElementNotes: (() => {
          const notes = [];
          const push = (elementType, itemElement, note) => {
            if (note) notes.push({ elementType, itemElement, note });
          };

          // Chief complaints
          selectedChiefComplains?.forEach((item) =>
            push('chiefComplain', item.name, item.note),
          );

          // Diagnoses
          selectedDiagnosis?.forEach((item) =>
            push('diagnosis', item.name, item.note),
          );

          // Observations
          selectedOnExamination?.observations?.forEach((item) =>
            push('observation', item.name, item.note),
          );

          // Investigations (use instruction as note)
          selectedInvestigations?.forEach((item) => {
            push('investigation', item.name, item.instruction || item.note);
            push('investigation', 'unit', item.unit);
          });

          // Advices
          selectedAdvices?.forEach((item) =>
            push('advice', item.name, item.note),
          );

          // Referred to
          selectedReferredto?.forEach((item) =>
            push('referredto', item.name, item.note),
          );

          // Treatment plans
          selectedTreatmentPlans?.forEach((item) =>
            push('treatmentPlan', item.name, item.note),
          );

          // Medical histories (General tab)
          selectedHistories?.medical?.forEach((item) =>
            push('history', item.name, item.note),
          );

          // Family history
          push('history', 'family', selectedHistories?.family);

          // Personal history
          push('history', 'personal', selectedHistories?.personal?.notes);

          // Others history
          push(
            'history',
            'surgicalHistory',
            selectedHistories?.others?.surgicalHistory,
          );
          push(
            'history',
            'allergicHistory',
            selectedHistories?.others?.allergicHistory,
          );
          push('history', 'mhNote', selectedHistories?.others?.mh?.note);

          // Surgical history
          [
            'lucs',
            'appendicectomy',
            'cholecystectomy',
            'laparotomy',
            'laparoscopy',
            'tah',
            'ulso',
            'dlso',
            'others',
          ].forEach((field) =>
            push(
              'surgicalHistory',
              field,
              selectedHistories?.surgical?.[field],
            ),
          );

          // Oncology history
          push(
            'oncologyHistory',
            'chemoTherapy',
            selectedHistories?.oncology?.chemoTherapyNotes,
          );
          push(
            'oncologyHistory',
            'radioTherapy',
            selectedHistories?.oncology?.radioTherapyNotes,
          );
          push(
            'oncologyHistory',
            'hormonalTherapy',
            selectedHistories?.oncology?.hormonalTherapyNotes,
          );
          push(
            'oncologyHistory',
            'surgery',
            selectedHistories?.oncology?.surgeryNotes,
          );

          // Dynamic prescription items
          Object.entries(selectedDynamicItems || {}).forEach(
            ([itemName, items]) => {
              (items || []).forEach((item) =>
                push(itemName, item.name, item.note),
              );
            },
          );

          // Eye examination
          const eyeExamination = selectedOnExamination?.eyeExamination;
          if (eyeExamination) {
            EYE_EXAM_ITEMS.forEach(({ key }) => {
              const right = eyeExamination[key]?.right;
              const left = eyeExamination[key]?.left;
              if (right) push('eyeExamination', `${key}_right`, right);
              if (left) push('eyeExamination', `${key}_left`, left);
            });
          }

          // General note
          push('note', 'prescription', note);

          // Urology examination
          const urologyExamination = selectedOnExamination?.urologyExamination;
          if (urologyExamination) {
            [
              'analSensation',
              'analTone',
              'size',
              'consistency',
              'tenderness',
              'surface',
              'nodularity',
              'analMucosa',
              'upperBorder',
              'medianSulcus',
              'eum',
              'phallus',
              'antUrethra',
              'scrutum',
              'testes',
              'epididymis',
              'vas',
              'pampiniformPlexus',
              'showBiliaryPicture',
              'showDigestivePicture',
            ].forEach((field) =>
              push(
                'urologyExamination',
                field,
                urologyExamination[field]?.note,
              ),
            );
          }

          // Rehabilitation
          selectedRehabilitation?.physicalTherapies?.forEach((item) =>
            push('physicalTherapy', item.name, item.note),
          );
          selectedRehabilitation?.exercises?.forEach((item) =>
            push('exercise', item.name, item.note),
          );
          selectedRehabilitation?.orthoses?.forEach((item) =>
            push('orthosis', item.name, item.note),
          );

          // Infertility
          selectedInfertilities?.woman?.forEach((item) =>
            push('infertility', item.name, item.instruction),
          );
          selectedInfertilities?.man?.forEach((item) =>
            push('infertility', item.name, item.instruction),
          );

          // Systemic examination
          const systemicExamination =
            selectedOnExamination?.systemicExamination;
          if (systemicExamination) {
            [
              'jvp',
              'lph',
              'palpableP2',
              'heartSound',
              'murmur',
              'lungBase',
            ].forEach((field) =>
              push(
                'systemicExamination',
                field,
                systemicExamination[field]?.note,
              ),
            );
            ['apexBeatNote', 'rsNote', 'gsNote', 'cnsNote'].forEach((field) =>
              push('systemicExamination', field, systemicExamination[field]),
            );
          }

          // Gyne examination
          const gyneExamination = selectedOnExamination?.gyneExamination;
          if (gyneExamination) {
            [
              'os',
              'effacement',
              'station',
              'nadNote',
              'lump',
              'inspectionNadNote',
              'dischargeNote',
              'pawNote',
            ].forEach((field) =>
              push('gyneExamination', field, gyneExamination[field]),
            );
          }

          // Breast examination
          const breastExamination = selectedOnExamination?.breastExamination;
          if (breastExamination) {
            push('breastExamination', 'note', breastExamination.note);
            push('breastExamination', 'findings', breastExamination.findings);
          }

          // ENT examination
          const earNoseThroths = selectedOnExamination?.earNoseThroths;
          if (earNoseThroths) {
            [
              'larynx',
              'hypopharynx',
              'tongue',
              'oral_cavity',
              'oropharynx',
              'sinonasal',
              'thyroid',
              'salivary_gland',
              'skin',
              'site',
              'level',
              'size',
              'consistency',
              'structure',
            ].forEach((field) =>
              push('earNoseThroths', field, earNoseThroths[field]?.note),
            );
            push('earNoseThroths', 'nasopharynx', earNoseThroths.nasopharynx);
            push('earNoseThroths', 'lymphoma', earNoseThroths.lymphoma);
          }

          // Mental state examination
          const mentalStateExamination =
            selectedOnExamination?.mentalStateExamination;
          if (mentalStateExamination) {
            [
              'appearanceAndBehavior',
              'speech',
              'moodAndAffect',
              'perception',
              'thoughtProcess',
              'thoughtContent',
              'insight',
              'judgment',
              'cognition',
            ].forEach((field) =>
              push(
                'mentalStateExamination',
                field,
                mentalStateExamination[field],
              ),
            );
          }

          // Nervous system (neurology)
          const nervousSystem = selectedOnExamination?.nervousSystem;
          if (nervousSystem) {
            [
              'gcs',
              'consciousness',
              'orientation',
              'memory',
              'delusion',
              'hallucination',
              'mmse',
              'speech',
              'cranialNerves',
              'wasting',
              'power',
              'gaitFunction',
              'cerebellarFunction',
              'sensorySystem',
              'neckRigidity',
              'kernigSign',
              'brudzinskiSign',
              'jvp',
              'pulse',
              'murmur',
              'ascitis',
              'hepatomegaly',
              'splenomegaly',
              'rr',
              'rhanchi',
              'creps',
              'breathSound',
            ].forEach((field) =>
              push('nervousSystem', field, nervousSystem[field]?.note),
            );
            Object.entries(nervousSystem?.jerks || {}).forEach(([key, val]) =>
              push('nervousSystem', `jerks_${key}`, val?.note),
            );
            Object.entries(nervousSystem?.plantorResponse || {}).forEach(
              ([key, val]) =>
                push('nervousSystem', `plantorResponse_${key}`, val?.note),
            );
          }

          return notes;
        })(),
      };

      const requestPrescription =
        prescriptionId &&
        moment(appointmentDateTime).format('YYYY-MM-DD') ===
          moment().format('YYYY-MM-DD')
          ? patchRequest('prescriptions/' + prescriptionId, prescriptionArr)
          : postRequest('prescriptions', prescriptionArr);

      await requestPrescription
        .then((data) => {
          setAppointmentStatus('completed');
          if (prescriptionArr.prescriptionItemElementNotes?.length > 0) {
            const existingKeys = new Set(
              allItemElementNotes.map(
                (n) => `${n.elementType}::${n.itemElement}::${n.note}`,
              ),
            );
            const newNotes =
              prescriptionArr.prescriptionItemElementNotes.filter(
                (n) =>
                  !existingKeys.has(
                    `${n.elementType}::${n.itemElement}::${n.note}`,
                  ),
              );
            if (newNotes.length > 0) {
              dispatch(itemElementNotes([...allItemElementNotes, ...newNotes]));
            }
          }
          // setNote('');
          if (files.length && title) {
            const attachFd = new FormData();
            attachFd.append('name', title);
            attachFd.append('patientId', patientInfo.id);
            attachFd.append('prescriptionId', data.id);
            files.forEach((f) => attachFd.append('files', f));
            handleSubmitAttachment(attachFd);
          }
          setPrescriptionId(data.id);

          if (submitType === 'saveAndPrint') {
            setLoadingStatus(false);
            callbackPrint();
          } else {
            // toast.success('Successfully created', {
            //   position: toast.POSITION.TOP_RIGHT,
            // });
            setTimeout(function () {
              setLoadingStatus(false);
            }, 1500);
          }
        })
        .catch((error) => {
          setLoadingStatus(false);
          console.log(error);
        });
    }
  };
  const getErrorMessage = (inputName) => {
    return errors[inputName] ? errors[inputName] : '';
  };

  const handleSubmitAttachment = (formData) => {
    postRequest('attachments', formData).then((data) => {
      console.log(data);
    });
  };

  const actualWidth = prescriptionSetting?.page?.width?.quantity;

  const closeModalOutside = () => {
    setShowHistory(false);
    setShowInvestigation(false);
    setShowOnExamination(false);
    setShowDiagnosis(false);
    setShowAdvice(false);
    setShowInfertility(false);
    setShowFollowUp(false);
    setShowEyeGlass(false);
    setShowRehabilitation(false);
    setShowPredictions(false);
    setEditMedicineId('');
    setSelectedOnExaminationTab('observation');
  };

  const deletePrescriptionItem = (type, itemId) => {
    if (type === 'diagnosis') {
      setSelectedDiagnosis(
        selectedDiagnosis.filter((diagnosis) => diagnosis.name !== itemId),
      );
    } else if (type === 'investigation') {
      setSelectedInvestigations(
        selectedInvestigations.filter(
          (investigation) => investigation.name !== itemId,
        ),
      );
    } else if (type === 'chiefComplain') {
      setSelectedChiefComplains(
        selectedChiefComplains.filter((chief) => chief.name !== itemId),
      );
    } else if (type === 'treatmentPlan') {
      setSelectedTreatmentPlans(
        selectedTreatmentPlans?.filter((treat) => treat.name !== itemId),
      );
    } else if (type === 'referredto') {
      setSelectedReferredto(
        selectedReferredto?.filter((referred) => referred.name !== itemId),
      );
    } else if (type === 'followup') {
      setSelectedFollowUps(
        selectedFollowUps.filter((followup) => followup !== itemId),
      );
    } else if (type === 'onExamination') {
      const observations = [
        ...selectedOnExamination.observations.filter(
          (observation) => observation.name !== itemId,
        ),
      ];
      selectedOnExamination.observations = observations;
      setSelectedOnExamination({ ...selectedOnExamination });
    } else if (type === 'eyeGlassTable') {
      setSelectedEyeGlass({
        isPlano: false,
        leftPlano: false,
        r: { sph: '', cyl: '', axis: '' },
        l: { sph: '', cyl: '', axis: '' },
        remarks: [],
      });
    } else if (type === 'eyeGlassRemark') {
      const result = selectedEyeGlass.remarks.filter(
        (remark) => remark !== itemId,
      );
      setSelectedEyeGlass({ ...selectedEyeGlass, remarks: result });
    }
  };

  // const wrapWithGap = (element, view) => {
  //   const mb = element.marginBottom;
  //   if (!mb) {
  //     return <div style={{ marginBottom: '30px' }}>{view}</div>;
  //   }
  //   let cssValue;
  //   if (typeof mb === 'object' && mb.value) {
  //     cssValue = `${mb.value}${mb.unit || 'px'}`;
  //   } else {
  //     const num = parseFloat(mb);
  //     if (!num) return view;
  //     cssValue = `${num}px`;
  //   }
  //   return (
  //     <div key={`gap-${element.name}`} style={{ marginBottom: cssValue }}>
  //       {view}
  //     </div>
  //   );
  // };

  const chiefComplainView = (element, type) => {
    if (
      type === 'print' &&
      (selectedChiefComplains.length === 0 || hideItems?.['chief-complain'])
    ) {
      return false;
    }
    return (
      <ChiefComplainView
        element={element}
        key={'chiefComplain'}
        prescriptionItems={prescriptionItems}
        setIsComplainModal={setIsComplainModal}
        selectedChiefComplains={selectedChiefComplains}
        setSelectedChiefComplains={setSelectedChiefComplains}
        deletePrescriptionItem={deletePrescriptionItem}
      />
    );
  };

  const treatmentPlanView = (element, type) => {
    if (
      type === 'print' &&
      (selectedTreatmentPlans?.length === 0 || hideItems?.['treatment-plan'])
    ) {
      return false;
    }
    return (
      <TreatmentPlanView
        element={element}
        key={'treatmentPlan'}
        prescriptionItems={prescriptionItems}
        setIsTreatmentPlanModal={setIsTreatmentPlanModal}
        selectedTreatmentPlans={selectedTreatmentPlans}
        setSelectedTreatmentPlans={setSelectedTreatmentPlans}
        deletePrescriptionItem={deletePrescriptionItem}
      />
    );
  };

  const dynamicItemView = (element, type) => {
    const itemName = element.name;
    const items = selectedDynamicItems[itemName] || [];
    if (type === 'print' && (items.length === 0 || hideItems?.[itemName])) {
      return false;
    }
    return (
      <DynamicPrescriptionItemView
        element={element}
        key={itemName}
        prescriptionItems={prescriptionItems}
        setIsModalOpen={() => setDynamicItemModalName(itemName)}
        selectedItems={items}
        setSelectedItems={(newItems) =>
          setSelectedDynamicItems((prev) => ({ ...prev, [itemName]: newItems }))
        }
        deleteItem={(delItemName) =>
          setSelectedDynamicItems((prev) => ({
            ...prev,
            [itemName]: (prev[itemName] || []).filter(
              (i) => i.name !== delItemName,
            ),
          }))
        }
      />
    );
  };

  const historyView = (element, type, isInRightSide) => {
    if (
      type === 'print' &&
      (!isExistAnyHistory(selectedHistories) || hideItems?.history)
    ) {
      return false;
    }
    return (
      <HistoryView
        element={element}
        key={'history'}
        setShowHistory={setShowHistory}
        selectedHistories={selectedHistories}
        setSelectedHistories={setSelectedHistories}
        deletePrescriptionItem={deletePrescriptionItem}
        isInRightSide={isInRightSide}
      />
    );
  };

  const onExaminationView = (element, type, isInRightSide) => {
    if (
      type === 'print' &&
      (!isExistAnyOnExamination(selectedOnExamination) ||
        hideItems?.['on-examination'])
    ) {
      return false;
    }
    return (
      <OnExaminationView
        element={element}
        key={'onExamination'}
        deletePrescriptionItem={deletePrescriptionItem}
        selectedOnExamination={selectedOnExamination}
        setShowOnExamination={setShowOnExamination}
        prescriptionItems={prescriptionItems}
        setSelectedOnExamination={setSelectedOnExamination}
        isInRightSide={isInRightSide}
      />
    );
  };

  const predictionsView = (element, type) => {
    if (type === 'print' && !isExistAnyOnExamination(selectedOnExamination)) {
      return false;
    }
    return (
      <PredictionsView
        element={element}
        key={'onExamination'}
        deletePrescriptionItem={deletePrescriptionItem}
        selectedOnExamination={selectedOnExamination}
        setShowPredictions={setShowPredictions}
        prescriptionItems={prescriptionItems}
        setSelectedOnExamination={setSelectedOnExamination}
      />
    );
  };

  const investigationView = (element, type) => {
    if (
      type === 'print' &&
      (selectedInvestigations.length === 0 || hideItems?.investigation)
    ) {
      return false;
    }
    return (
      <InvestigationView
        element={element}
        key={'investigation'}
        prescriptionItems={prescriptionItems}
        setShowInvestigation={setShowInvestigation}
        selectedInvestigations={selectedInvestigations}
        setSelectedInvestigations={setSelectedInvestigations}
        deletePrescriptionItem={deletePrescriptionItem}
      />
    );
  };

  const adviceView = (element, type, isInLeftSide) => {
    if (
      type === 'print' &&
      (selectedAdvices.length === 0 || hideItems?.advice)
    ) {
      return false;
    }
    return (
      <AdviceView
        element={element}
        key={'advice'}
        prescriptionItems={prescriptionItems}
        setShowAdvice={setShowAdvice}
        selectedAdvices={selectedAdvices}
        setSelectedAdvices={setSelectedAdvices}
        deletePrescriptionItem={deletePrescriptionItem}
        isInLeftSide={isInLeftSide}
      />
    );
  };

  const followUpView = (element, type) => {
    if (
      type === 'print' &&
      (selectedFollowUps.length === 0 || hideItems?.['follow-up'])
    ) {
      return false;
    }
    return (
      <FollowUpView
        element={element}
        key={'followUp'}
        prescriptionItems={prescriptionItems}
        setShowFollowUp={setShowFollowUp}
        selectedFollowUps={selectedFollowUps}
        setSelectedFollowUps={setSelectedFollowUps}
        deletePrescriptionItem={deletePrescriptionItem}
      />
    );
  };

  const eyeGlassView = (element, type) => {
    if (
      type === 'print' &&
      (!isExistAnyEyeGlass(selectedEyeGlass) || hideItems?.['eye-glass'])
    ) {
      return false;
    }
    return (
      <EyeGlassView
        selectedEyeGlass={selectedEyeGlass}
        setSelectedEyeGlass={setSelectedEyeGlass}
        setShowEyeGlass={setShowEyeGlass}
        deletePrescriptionItem={deletePrescriptionItem}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'eyeGlass'}
      />
    );
  };

  const viewDiagnosis = (element, type) => {
    console.log('diagnosisViewhide', selectedStage?.isShow);
    if (
      type === 'print' &&
      ((selectedDiagnosis?.length === 0 && !selectedStage?.isShow) ||
        hideItems?.diagnosis)
    ) {
      return false;
    }
    return (
      <DiagnosisView
        key={'diagnosis'}
        selectedDiagnosis={selectedDiagnosis}
        setSelectedDiagnosis={setSelectedDiagnosis}
        setShowDiagnosis={setShowDiagnosis}
        prescriptionItems={prescriptionItems}
        deletePrescriptionItem={deletePrescriptionItem}
        selectedStage={selectedStage}
        element={element}
      />
    );
  };

  const viewRehabilitation = (element, type) => {
    if (
      type === 'print' &&
      (!isExistAnyRehabData(selectedRehabilitation) ||
        hideItems?.rehabilitation)
    ) {
      return false;
    }
    return (
      <RehabilitationView
        selectedRehabilitation={selectedRehabilitation}
        setSelectedRehabilitation={setSelectedRehabilitation}
        setShowRehabilitation={setShowRehabilitation}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'rehabilitation'}
      />
    );
  };

  const viewRx = (element, type) => {
    if (type === 'print' && (selectedMedicines.length === 0 || hideItems?.rx)) {
      return false;
    }
    return (
      <RxView
        selectedMedicines={selectedMedicines}
        setSelectedMedicines={setSelectedMedicines}
        setShowRx={setShowRx}
        // deletePrescriptionItem={deletePrescriptionItem}
        instructions={instructions}
        setInstructions={setInstructions}
        prescriptionItems={prescriptionItems}
        editMedicineId={editMedicineId}
        setEditMedicineId={setEditMedicineId}
        element={element}
        type={type}
        key={'rx'}
        showMedicineName={showMedicineName}
        setShowMedicineName={setShowMedicineName}
        medicineType={medicineType}
        interactionData={interactionData}
        acknowledgedPairs={acknowledgedPairs}
        onAcknowledgeInteraction={handleAcknowledgeInteraction}
      />
    );
  };

  const infertilityView = (element, type) => {
    if (
      type === 'print' &&
      (!isExistAnyInfertilityData(selectedInfertilities) ||
        hideItems?.infertility)
    ) {
      return false;
    }
    return (
      <InfertilityView
        element={element}
        key={'infertility'}
        setShowInfertility={setShowInfertility}
        selectedInfertilities={selectedInfertilities}
        setSelectedInfertilities={setSelectedInfertilities}
      />
    );
  };

  const specialNoteView = (element, type) => {
    if (
      type === 'print' &&
      (selectedSpecialNotes.length === 0 || hideItems?.['special-note'])
    ) {
      return false;
    }
    return (
      <SpecialNoteView
        selectedSpecialNotes={selectedSpecialNotes}
        setSelectedSpecialNotes={setSelectedSpecialNotes}
        setShowSpecialNote={setShowSpecialNote}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'specialNote'}
      />
    );
  };

  const signatureView = (element, type) => {
    if (type === 'print' && hideItems?.signature) {
      return false;
    }
    return (
      <SignatureView
        key={'signature'}
        element={element}
        userInfo={userInfo}
        isPrescription={true}
        isPad={isPad}
        prescriptionSetting={prescriptionSetting}
      />
    );
  };

  const referredToView = (element, type) => {
    if (
      type === 'print' &&
      (!selectedReferredto?.length || hideItems?.['referred-to'])
    ) {
      return false;
    }

    return (
      <ReferredtoView
        element={element}
        key={'referredto'}
        prescriptionItems={prescriptionItems}
        setIsReferredToModal={setIsReferredToModal}
        selectedReferredto={selectedReferredto}
        setSelectedReferredto={setSelectedReferredto}
        deletePrescriptionItem={deletePrescriptionItem}
      />
    );
  };

  return (
    <div
      onClick={() => {
        closeModalOutside();
      }}
    >
      <Header />
      <div className="container-fluid">
        <PrescriptionTopContext.Provider
          value={{
            selectedAdvicesGroups,
            selectedComplainGroups,
            selectedDiagnosisGroups,
            selectedInfertilityManGroups,
            selectedMedicineGroups,
            selectedInvestigationGroups,
            selectedTemplates,
            patientInfo,
            toggleTemplateSelection,
          }}
        >
          <PrescriptionTop
            printRef={printRef}
            title={title}
            setTitle={setTitle}
            files={files}
            setFiles={setFiles}
            handlePrintStatus={handlePrintStatus}
            prescriptionId={prescriptionId}
            //patientInfo={patientInfo}
            note={note}
            setNote={setNote}
            openVideoModal={openVideoModal}
            setOpenVideoModal={setOpenVideoModal}
            onlineUserExist={onlineUserExist}
            setOnlineUserExist={setOnlineUserExist}
          />
        </PrescriptionTopContext.Provider>
        <Row className="rx-body">
          <small className="v-error">{getErrorMessage('name')}</small>
          <div className="col-xl-12 col-md-12 col-lg-12 col-sm-12">
            <div
              className={`card shadow mb-4 ${
                userInfo?.signaturePosition && isPad ? 'relative-card-body' : ''
              }`}
            >
              {/* card body normal view */}
              <div className="card-body normal-card-body">
                {loadingStatus && (
                  <div className="saved-image-over">
                    <img src={loadingImg} height={200} width={200} />
                  </div>
                )}
                <PrescriptionHeader
                  patientId={patientInfo?.id}
                  headerInfo={header}
                  prescriptionSetting={prescriptionSetting}
                />
                <PatientSection
                  patientPicture={patientPicture}
                  patientInfo={patientInfo}
                  patientList={patientList}
                  appointmentInfo={appointmentInfo}
                  setAppointmentInfo={setAppointmentInfo}
                  prescriptionSetting={prescriptionSetting}
                  setPatientInfo={setPatientInfo}
                  selectedOnExamination={selectedOnExamination}
                  setSelectedOnExamination={setSelectedOnExamination}
                  actualWidth={actualWidth}
                  isPad={isPad}
                  hideItems={hideItems}
                />
                <div className="row pl-2 pr-2 pb-3 prescription-body-print">
                  {leftOrRightItems(prescriptionItems, 'left').length > 0 && (
                    <div
                      className={`prescription-body-left ${
                        isPad ? '' : 'blank-prescription-print-left'
                      }`}
                      style={{ paddingLeft: '28px', width: '35%' }}
                    >
                      {leftOrRightItems(prescriptionItems, 'left').map(
                        (element) => {
                          let view;
                          if (element.name === 'chief-complain') {
                            view = chiefComplainView(element);
                          } else if (element.name === 'treatment-plan') {
                            view = treatmentPlanView(element);
                          } else if (element.name === 'referred-to') {
                            view = referredToView(element);
                          } else if (element.name === 'history') {
                            view = historyView(element);
                          } else if (element.name === 'on-examination') {
                            view = onExaminationView(element);
                          } else if (element.name === 'diagnosis') {
                            view = viewDiagnosis(element);
                          } else if (element.name === 'investigation') {
                            view = investigationView(element);
                          } else if (element.name === 'rx') {
                            view = viewRx(element);
                          } else if (element.name === 'rehabilitation') {
                            view = viewRehabilitation(element);
                          } else if (element.name === 'advice') {
                            view = adviceView(element, '', true);
                          } else if (element.name === 'follow-up') {
                            view = followUpView(element);
                          } else if (element.name === 'eye-glass') {
                            view = eyeGlassView(element);
                          } else if (element.name === 'infertility') {
                            view = infertilityView(element);
                          } else if (element.name === 'special-note') {
                            view = specialNoteView(element);
                          } else if (element.name === 'signature') {
                            view = signatureView(element);
                          } else {
                            view = dynamicItemView(element);
                          }
                          return view;
                        },
                      )}
                    </div>
                  )}
                  {leftOrRightItems(prescriptionItems, 'right').length > 0 && (
                    <div
                      className={`prescription-body-right ${
                        isPad ? '' : 'blank-prescription-print-right'
                      }`}
                      style={{ paddingLeft: '25px', width: '60%' }}
                    >
                      {leftOrRightItems(prescriptionItems, 'right').map(
                        (element) => {
                          let view;
                          if (element.name === 'chief-complain') {
                            view = chiefComplainView(element);
                          } else if (element.name === 'treatment-plan') {
                            view = treatmentPlanView(element);
                          } else if (element.name === 'referred-to') {
                            view = referredToView(element);
                          } else if (element.name === 'history') {
                            view = historyView(element, '', true);
                          } else if (element.name === 'on-examination') {
                            view = onExaminationView(element, '', true);
                          } else if (element.name === 'diagnosis') {
                            view = viewDiagnosis(element);
                          } else if (element.name === 'investigation') {
                            view = investigationView(element);
                          } else if (element.name === 'rx') {
                            view = viewRx(element);
                          } else if (element.name === 'rehabilitation') {
                            view = viewRehabilitation(element);
                          } else if (element.name === 'advice') {
                            view = adviceView(element);
                          } else if (element.name === 'follow-up') {
                            view = followUpView(element);
                          } else if (element.name === 'eye-glass') {
                            view = eyeGlassView(element);
                          } else if (element.name === 'infertility') {
                            view = infertilityView(element);
                          } else if (element.name === 'special-note') {
                            view = specialNoteView(element);
                          } else if (element.name === 'signature') {
                            view = signatureView(element);
                          } else if (element.name === 'predictions') {
                            view = predictionsView(element);
                          } else {
                            view = dynamicItemView(element);
                          }
                          return view;
                        },
                      )}
                    </div>
                  )}
                </div>

                <hr style={{ backgroundColor: 'black' }} className="hr" />
                <PrescriptionFooter
                  footerInfo={footer}
                  prescriptionSetting={prescriptionSetting}
                  printStatus={printStatus}
                />
              </div>
              {/* card body print view */}
              <div
                className={`
                  card-body print-card-body
                  ${isPad ? '' : 'blank-prescription-card-body'}`}
                style={
                  isPad ? pagePrintStyle(prescriptionSetting, actualWidth) : {}
                }
                ref={printRef}
              >
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    tableLayout: 'fixed',
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ padding: 0, border: 'none' }}>
                        <PrescriptionHeader
                          patientPicture={patientPicture}
                          patientId={patientInfo?.id}
                          headerInfo={header}
                          prescriptionSetting={prescriptionSetting}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tfoot>
                    <tr>
                      <td style={{ padding: 0, border: 'none' }}>
                        <PrescriptionFooter
                          footerInfo={footer}
                          prescriptionSetting={prescriptionSetting}
                          printStatus={printStatus}
                        />
                      </td>
                    </tr>
                  </tfoot>
                  <tbody>
                    <tr>
                      <td style={{ padding: 0, border: 'none' }}>
                        <PatientSection
                          patientPicture={patientPicture}
                          patientInfo={patientInfo}
                          appointmentInfo={appointmentInfo}
                          patientList={patientList}
                          prescriptionSetting={prescriptionSetting}
                          setPatientInfo={setPatientInfo}
                          selectedOnExamination={selectedOnExamination}
                          setSelectedOnExamination={setSelectedOnExamination}
                          isPad={isPad}
                          hideItems={hideItems}
                        />
                        <div className="row prescription-body-print">
                          {leftOrRightItems(prescriptionItems, 'left').length >
                            0 && (
                            <div
                              style={leftSidePrintStyle(
                                isPad,
                                prescriptionSetting,
                              )}
                              className={`prescription-body-left
                        ${isPad ? '' : 'blank-prescription-print-left'}`}
                            >
                              {leftOrRightItems(prescriptionItems, 'left').map(
                                (element) => {
                                  let view;
                                  if (element.name === 'chief-complain') {
                                    view = chiefComplainView(element, 'print');
                                  } else if (
                                    element.name === 'treatment-plan'
                                  ) {
                                    view = treatmentPlanView(element, 'print');
                                  } else if (element.name === 'referred-to') {
                                    view = referredToView(element, 'print');
                                  } else if (
                                    element.name === 'treatment-lain'
                                  ) {
                                    view = historyView(element, 'print');
                                  } else if (element.name === 'history') {
                                    view = historyView(element, 'print');
                                  } else if (
                                    element.name === 'on-examination'
                                  ) {
                                    view = onExaminationView(element, 'print');
                                  } else if (element.name === 'diagnosis') {
                                    view = viewDiagnosis(element, 'print');
                                  } else if (element.name === 'investigation') {
                                    view = investigationView(element, 'print');
                                  } else if (element.name === 'rx') {
                                    view = viewRx(element, 'print');
                                  } else if (
                                    element.name === 'rehabilitation'
                                  ) {
                                    view = viewRehabilitation(element, 'print');
                                  } else if (element.name === 'advice') {
                                    view = adviceView(element, 'print');
                                  } else if (element.name === 'follow-up') {
                                    view = followUpView(element, 'print');
                                  } else if (element.name === 'eye-glass') {
                                    view = eyeGlassView(element, 'print');
                                  } else if (element.name === 'infertility') {
                                    view = infertilityView(element, 'print');
                                  } else if (element.name === 'special-note') {
                                    view = specialNoteView(element, 'print');
                                  } else if (
                                    element.name === 'signature' &&
                                    !userInfo?.signaturePosition
                                  ) {
                                    view = signatureView(element, 'print');
                                  } else {
                                    view = dynamicItemView(element, 'print');
                                  }
                                  return view;
                                },
                              )}
                            </div>
                          )}
                          {leftOrRightItems(prescriptionItems, 'right').length >
                            0 && (
                            <div
                              style={
                                isPad
                                  ? rightSidePrintStyle(prescriptionSetting)
                                  : {
                                      width:
                                        prescriptionSetting?.prescriptionBody
                                          ?.rightContent?.width?.quantity !=
                                        null
                                          ? `${prescriptionSetting.prescriptionBody.rightContent.width.quantity}${prescriptionSetting.prescriptionBody.rightContent.width.unit ?? ''}`
                                          : undefined,
                                    }
                              }
                              className={`prescription-body-right
                            ${isPad ? '' : 'blank-prescription-print-right'}`}
                            >
                              {leftOrRightItems(prescriptionItems, 'right').map(
                                (element) => {
                                  let view;
                                  if (element.name === 'chief-complain') {
                                    view = chiefComplainView(element, 'print');
                                  } else if (
                                    element.name === 'treatment-plan'
                                  ) {
                                    view = treatmentPlanView(element, 'print');
                                  } else if (element.name === 'referred-to') {
                                    view = referredToView(element, 'print');
                                  } else if (element.name === 'history') {
                                    view = historyView(element, 'print', true);
                                  } else if (
                                    element.name === 'on-examination'
                                  ) {
                                    view = onExaminationView(element, 'print');
                                  } else if (element.name === 'diagnosis') {
                                    view = viewDiagnosis(element, 'print');
                                  } else if (element.name === 'investigation') {
                                    view = investigationView(element, 'print');
                                  } else if (element.name === 'rx') {
                                    view = viewRx(element, 'print');
                                  } else if (
                                    element.name === 'rehabilitation'
                                  ) {
                                    view = viewRehabilitation(element, 'print');
                                  } else if (element.name === 'advice') {
                                    view = adviceView(element, 'print');
                                  } else if (element.name === 'follow-up') {
                                    view = followUpView(element, 'print');
                                  } else if (element.name === 'eye-glass') {
                                    view = eyeGlassView(element, 'print');
                                  } else if (element.name === 'infertility') {
                                    view = infertilityView(element, 'print');
                                  } else if (element.name === 'special-note') {
                                    view = specialNoteView(element, 'print');
                                  } else if (
                                    element.name === 'signature' &&
                                    !userInfo?.signaturePosition
                                  ) {
                                    view = signatureView(element, 'print');
                                  } else {
                                    view = dynamicItemView(element, 'print');
                                  }
                                  return view;
                                },
                              )}
                            </div>
                          )}
                        </div>

                        <BarcodeQrCode
                          patientInfo={patientInfo}
                          prescriptionId={
                            prescriptionId ?? prescriptionIdForCode
                          }
                        />
                        {userInfo?.signaturePosition &&
                          isPad &&
                          !hideItems?.signature && (
                            <SignatureView
                              key={'signature-fixed'}
                              element={
                                prescriptionItems?.items?.signature || {}
                              }
                              userInfo={userInfo}
                              isPrescription={true}
                              isPad={isPad}
                              prescriptionSetting={prescriptionSetting}
                            />
                          )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Row>

        <ChiefComplainModal
          modalTitle={rxItemName('chief-complain')}
          isComplainModal={isComplainModal}
          setIsComplainModal={setIsComplainModal}
          selectedChiefComplains={selectedChiefComplains}
          setSelectedChiefComplains={setSelectedChiefComplains}
          selectedComplainGroups={selectedComplainGroups}
          setSelectedComplainGroups={setSelectedComplainGroups}
        />
        <ReferredToModal
          modalTitle={rxItemName('referredto')}
          isReferredToModal={isReferredToModal}
          setIsReferredToModal={setIsReferredToModal}
          selectedReferredto={selectedReferredto}
          setSelectedReferredto={setSelectedReferredto}
          selectedReferredtoGroups={selectedReferredtoGroups}
          setSelectedReferredtoGroups={setSelectedReferredtoGroups}
        />
        <TreatmentPlanModal
          modalTitle={rxItemName('treatment-plan')}
          isTreatmentPlanModal={isTreatmentPlanModal}
          setIsTreatmentPlanModal={setIsTreatmentPlanModal}
          selectedTreatmentPlans={selectedTreatmentPlans}
          setSelectedTreatmentPlans={setSelectedTreatmentPlans}
          selectedTreatmentPlansGroups={selectedTreatmentPlansGroups}
          setSelectedTreatmentPlansGroups={setSelectedTreatmentPlansGroups}
        />
        {dynamicItemModalName && (
          <DynamicPrescriptionItemModal
            itemName={dynamicItemModalName}
            modalTitle={
              prescriptionItems?.items?.[dynamicItemModalName]?.alterName ||
              dynamicItemModalName
                .replace(/-/g, ' ')
                .replace(/\b\w/g, (c) => c.toUpperCase())
            }
            isOpen={!!dynamicItemModalName}
            setIsOpen={(open) => !open && setDynamicItemModalName('')}
            selectedItems={selectedDynamicItems[dynamicItemModalName] || []}
            setSelectedItems={(items) =>
              setSelectedDynamicItems((prev) => ({
                ...prev,
                [dynamicItemModalName]: items,
              }))
            }
            selectedGroups={selectedDynamicGroups[dynamicItemModalName] || []}
            setSelectedGroups={(groups) =>
              setSelectedDynamicGroups((prev) => ({
                ...prev,
                [dynamicItemModalName]: groups,
              }))
            }
          />
        )}
        <HistoryContext.Provider
          value={{
            selectedMedicines,
            setSelectedMedicines,
          }}
        >
          <HistoryModal
            modalTitle={rxItemName('history')}
            showHistory={showHistory}
            setShowHistory={setShowHistory}
            selectedHistories={selectedHistories}
            setSelectedHistories={setSelectedHistories}
            selectedHistoryTab={selectedHistoryTab}
            setSelectedHistoryTab={setSelectedHistoryTab}
          />
        </HistoryContext.Provider>
        <OnExaminationModal
          modalTitle={rxItemName('on-examination')}
          patientInfo={patientInfo}
          setPatientInfo={setPatientInfo}
          showOnExamination={showOnExamination}
          setShowOnExamination={setShowOnExamination}
          onExaminationModalClose={closeOnExaminationModal}
          handleOnExaminations={handleOnExaminations}
          selectedOnExamination={selectedOnExamination}
          setSelectedOnExamination={setSelectedOnExamination}
          selectedOnExaminationTab={selectedOnExaminationTab}
          setSelectedOnExaminationTab={setSelectedOnExaminationTab}
        />
        <PredictionsModal
          modalTitle={rxItemName('prediction')}
          patientInfo={patientInfo}
          setPatientInfo={setPatientInfo}
          showPredictions={showPredictions}
          setShowPredictions={setShowPredictions}
          onExaminationModalClose={closeOnExaminationModal}
          handleOnExaminations={handleOnExaminations}
          selectedOnExamination={selectedOnExamination}
          setSelectedOnExamination={setSelectedOnExamination}
          selectedOnExaminationTab={selectedOnExaminationTab}
          setSelectedOnExaminationTab={setSelectedOnExaminationTab}
        />
        <DiagnosisContext.Provider
          value={{
            selectedStage,
            setSelectedStage,
          }}
        >
          <DiagnosisModal
            modalTitle={rxItemName('diagnosis')}
            showDiagnosis={showDiagnosis}
            setShowDiagnosis={setShowDiagnosis}
            selectedDiagnosis={selectedDiagnosis}
            setSelectedDiagnosis={setSelectedDiagnosis}
            selectedDiagnosisTab={selectedDiagnosisTab}
            setSelectedDiagnosisTab={setSelectedDiagnosisTab}
            selectedDiagnosisGroups={selectedDiagnosisGroups}
            setSelectedDiagnosisGroups={setSelectedDiagnosisGroups}
          />
        </DiagnosisContext.Provider>
        <AdviceModal
          modalTitle={rxItemName('advice')}
          showAdvice={showAdvice}
          setShowAdvice={setShowAdvice}
          selectedAdvices={selectedAdvices}
          setSelectedAdvices={setSelectedAdvices}
          selectedAdvicesGroups={selectedAdvicesGroups}
          setSelectedAdvicesGroups={setSelectedAdvicesGroups}
        />
        <FollowUpModal
          modalTitle={rxItemName('follow-up')}
          showFollowUp={showFollowUp}
          setShowFollowUp={setShowFollowUp}
          selectedFollowUps={selectedFollowUps}
          setSelectedFollowUps={setSelectedFollowUps}
        />
        <RxContext.Provider
          value={{
            selectedMedicines,
            setSelectedMedicines,
            instructions,
            setInstructions,
            selectedMedicineGroups,
            setSelectedMedicineGroups,
            medicineGroups,
            setMedicineGroups,
          }}
        >
          <RxModal
            modalTitle={rxItemName('rx')}
            showRx={showRx}
            setShowRx={setShowRx}
            medicines={medicines}
            setMedicines={setMedicines}
            medicinesInSearch={medicinesInSearch}
            setMedicinesInSearch={setMedicinesInSearch}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            totalItem={totalItem}
            perPage={perPage}
            showMedicineName={showMedicineName}
            setShowMedicineName={setShowMedicineName}
          />
        </RxContext.Provider>
        <RehabilitationModal
          modalTitle={rxItemName('rehabilitation')}
          showRehabilitation={showRehabilitation}
          setShowRehabilitation={setShowRehabilitation}
          selectedRehabilitation={selectedRehabilitation}
          setSelectedRehabilitation={setSelectedRehabilitation}
        />
        <EyeGlassModal
          modalTitle={rxItemName('eye-glass')}
          showEyeGlass={showEyeGlass}
          setShowEyeGlass={setShowEyeGlass}
          selectedEyeGlass={selectedEyeGlass}
          setSelectedEyeGlass={setSelectedEyeGlass}
          deletePrescriptionItem={deletePrescriptionItem}
        />
        <InvestigationModal
          modalTitle={rxItemName('investigation')}
          showInvestigation={showInvestigation}
          setShowInvestigation={setShowInvestigation}
          selectedInvestigations={selectedInvestigations}
          setSelectedInvestigations={setSelectedInvestigations}
          selectedInvestigationGroups={selectedInvestigationGroups}
          setSelectedInvestigationGroups={setSelectedInvestigationGroups}
          selectedHistories={selectedHistories}
          setSelectedHistories={setSelectedHistories}
          isPrescriptionExist={location?.state?.history}
        />

        <InfertilityModal
          modalTitle={rxItemName('infertility')}
          showInfertility={showInfertility}
          setShowInfertility={setShowInfertility}
          selectedInfertilities={selectedInfertilities}
          setSelectedInfertilities={setSelectedInfertilities}
          selectedInfertilityWomenGroups={selectedInfertilityWomenGroups}
          setSelectedInfertilityWomenGroups={setSelectedInfertilityWomenGroups}
          selectedInfertilityManGroups={selectedInfertilityManGroups}
          setSelectedInfertilityManGroups={setSelectedInfertilityManGroups}
        />
        <SpecialNoteModal
          modalTitle={rxItemName('special-note')}
          showSpecialNote={showSpecialNote}
          setShowSpecialNote={setShowSpecialNote}
          selectedSpecialNotes={selectedSpecialNotes}
          setSelectedSpecialNotes={setSelectedSpecialNotes}
        />
      </div>
      <TemplateModal
        isTemplateModal={isTemplateModal}
        setIsTemplateModal={setIsTemplateModal}
        templateId={templateId}
        templateName={templateName}
        templateInput={{
          note: { note },
          organizationId: activeOrganization.id,
          chiefComplains: selectedChiefComplains,
          onExaminations: selectedOnExamination,
          diagnoses: selectedDiagnosis,
          staging: selectedStage,
          histories: selectedHistories,
          medicines: selectedMedicines,
          rehabilitation: selectedRehabilitation,
          advices: selectedAdvices,
          followUps: selectedFollowUps,
          investigations: selectedInvestigations,
          eyeGlass: selectedEyeGlass,
          specialNotes: selectedSpecialNotes,
          medicineIds: selectedMedicines.length
            ? selectedMedicines.map((item) => item.id)
            : [],
          // medicineIds: selectedMedicines.length
          //   ? selectedMedicines.map((item) => item.id)
          //   : [],
        }}
      />

      <PrescriptionSaveBtns
        prescriptionId={prescriptionId}
        loadingStatus={loadingStatus}
        resetPrescription={resetPrescription}
        handleSubmit={handleSubmit}
        isTemplateModal={isTemplateModal}
        setIsTemplateModal={setIsTemplateModal}
        templateId={templateId}
        patientInfo={patientInfo}
        selectedChiefComplains={selectedChiefComplains}
        selectedDiagnosis={selectedDiagnosis}
        selectedInvestigations={selectedInvestigations}
        selectedHistories={selectedHistories}
        selectedOnExamination={selectedOnExamination}
        selectedMedicines={selectedMedicines}
        selectedAdvices={selectedAdvices}
        selectedFollowUps={selectedFollowUps}
        leftOrRightItems={leftOrRightItems}
        setHideItems={setHideItems}
        hideItems={hideItems}
      />

      {openVideoModal && socket && (
        <VideoCallModal
          openVideoModal={openVideoModal}
          setOpenVideoModal={setOpenVideoModal}
          onlineUserExist={onlineUserExist}
          setOnlineUserExist={setOnlineUserExist}
          startCalling={startCalling}
          setStartCalling={setStartCalling}
          startVideo={startVideo}
          setStartVideo={setStartVideo}
          callTimeoutHandler={callTimeoutHandler}
          setCallTimeoutHandler={setCallTimeoutHandler}
          shouldClearTimeout={shouldClearTimeout}
          setShouldClearTimeout={setShouldClearTimeout}
          socket={socket}
          io={io}
          cancelCall={cancelCall}
          patientInfo={patientInfo}
          doctorInfo={userInfo}
        />
      )}
    </div>
  );
}

export default Prescription;
